import { appStyles } from './app.style';

interface ButtonInAppProps {
	label: string;
	onClick?: () => void;
	disabled?: boolean;
	style?: React.CSSProperties;
	type?: 'button' | 'submit';
}

export const ButtonInApp = ({
	label,
	onClick=() => {},
	disabled=false,
	style={},
	type='button'
}: ButtonInAppProps) => {

	return (
		<button 
			type={type} 
			onClick={onClick || (() => {})}
			style={{
				...appStyles.button, 
				fontSize: '0.8rem', 
				width: '30%',
				...(disabled && {
					background: '#cbd5e0',
					borderColor: '#cbd5e0',
					cursor: 'not-allowed',
					color: '#718096'
				}),
				...style
			}}
			disabled={disabled}
		>
			{ label }
		</button>

	)

}